import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

interface ConfirmDialog {
  title: string;
  description: string;
  highlightButton: string;
  unHighlightedButton: string;
  highlightButtonFunction: Function;
  unHighlightedButtonFunction: Function;
}

@Component({
  templateUrl: './fc-confirm-close-dialog.component.html',
  styleUrls: ['./fc-confirm-close-dialog.component.scss']
})

export class FcConfirmCloseDialogComponent implements OnInit {

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private dialogRef: MatDialogRef<FcConfirmCloseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialog,
    private translate: TranslateService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnInit(): void {
    this.setDefaultValues();
  }

  private setDefaultValues(): void {
    if (!this.data.title) {
      this.data.title = this.translate.instant('FC_CONFIRM_DIALOG.TITLE');
    }
    if (!this.data.description) {
      this.data.description = this.translate.instant('FC_CONFIRM_DIALOG.DESCRIPTION');
    }
    if (!this.data.highlightButton) {
      this.data.highlightButton = this.translate.instant('FC_CONFIRM_DIALOG.HIGHLIGHT_BUTTON');
    }
    if (!this.data.unHighlightedButton) {
      this.data.unHighlightedButton = this.translate.instant('FC_CONFIRM_DIALOG.UN_HIGHLIGHTED_BUTTON');
    }
  }

  highlightButtonFunction(): void {
    if (this.data.highlightButtonFunction) {
      this.data.highlightButtonFunction();
    }
    this.dialogRef.close();
  }

  unHighlightedButtonFunction(): void {
    if (this.data.unHighlightedButtonFunction) {
      this.data.unHighlightedButtonFunction();
    }
    this.dialogRef.close();
  }
}
